// src/bootstrap/auth.js
import Cookies from "js-cookie";
import {
  fetchUser,
  startTokenValidation,
  stopTokenValidation,
  clearAuthState,
} from "@/utils/auth";
import { showToast } from "@/utils/toastService";
import { initializeWebSocket, disconnectWebSocket } from "@/shared/realtime/websocket";

export async function initAuth() {
  const token = Cookies.get("auth_token");
  if (token) {
    try {
      await fetchUser();
      startTokenValidation();
      disconnectWebSocket();
      await initializeWebSocket();
    } catch (error) {
      showToast({
        severity: "error",
        summary: "Sesja wygasła",
        detail: "Twoja sesja wygasła. Zaloguj się ponownie.",
        life: 5000,
      });

      stopTokenValidation();
      disconnectWebSocket();
      clearAuthState();
    }
  }
}
